module.exports = __webpack_public_path__ + "img/defa-logo-red.2f222cda.svg";